/** Декоративный фон с radial-gradient и эллипсами. Требует родителя с `relative`. */
export const GradientEllipseBackground = () => (
  <div className="absolute inset-0 overflow-hidden">
    <div className="hidden md:block absolute inset-0 overflow-hidden bg-[radial-gradient(73.42%_73.42%_at_50%_90.43%,#5BDA00_0%,#000_100%)]">
      {/* Ellipse 20 — внешняя окружность (1456px) */}
      <div className="border-primary-800/22 absolute top-full left-1/2 size-364 -translate-x-1/2 -translate-y-101.5 rounded-full border-2" />
      {/* Ellipse 19 — внутренняя окружность (1180px) */}
      <div className="border-primary absolute top-full left-1/2 size-295 -translate-x-1/2 -translate-y-83.25 rounded-full border-2" />
      {/* Ellipse 18 — яркое пятно (1074px) */}
      <div className="absolute top-full left-1/2 size-268.5 -translate-x-1/2 -translate-y-88.25 rounded-full bg-linear-to-b from-[rgba(253,233,0,1)] to-[rgba(198,253,0,1)] blur-[70.6px]" />
    </div>

    {/* MOBILE */}
    <div className="md:hidden absolute inset-0 overflow-hidden bg-[radial-gradient(85%_100%_at_50%_100%,#5BDA00_0%,#000_80%)]">
      {/* Ellipse 18 — яркое пятно (mobile) */}
      <div className="absolute left-1/2 bottom-0 h-[min(64vw,290px)] w-[min(64vw,290px)] -translate-x-1/2 translate-y-[84%] rounded-full bg-linear-to-b from-[rgba(253,233,0,1)] to-[rgba(198,253,0,1)] blur-[min(5.6vw,22px)]" />
      {/* Ellipse 20 — внешняя окружность (mobile) */}
      <div className="border-primary-800/38 absolute left-1/2 bottom-0 h-[min(90vw,392px)] w-[min(90vw,392px)] -translate-x-1/2 translate-y-[84%] rounded-full border" />
      {/* Ellipse 19 — внутренняя окружность (mobile) */}
      <div className="border-primary absolute left-1/2 bottom-0 h-[min(74vw,300px)] w-[min(74vw,300px)] -translate-x-1/2 translate-y-[84%] rounded-full border" />
    </div>
  </div>
);
